import { Component, Input, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { OrdersItemsDetailDTO } from 'src/app/admin-api';

@Component({
  selector: 'app-product-row',
  templateUrl: './product-row.component.html',
  styleUrl: './product-row.component.scss'
})
export class ProductRowComponent {
  @Input() item!: OrdersItemsDetailDTO;

  private messageService: MessageService = inject(MessageService);

  getProductImageUrl(): string | null {
    return this.item?.defaultImageURL || null;
  }

  hasProductImage(): boolean {
    return !!(this.item?.defaultImageURL && this.item.defaultImageURL.trim());
  }

  canCopyValue(value: string | number | undefined): boolean {
    if (!value) {
      return false;
    }
    const textValue = String(value);
    return !!textValue.trim();
  }

  async copyToClipboard(
    value: string | number | undefined,
    fieldName: string
  ): Promise<void> {
    const textValue = String(value);

    try {
      await navigator.clipboard.writeText(textValue.trim());
      this.messageService.add({
        severity: 'success',
        summary: 'Copiado!',
        detail: `${fieldName} copiado para a área de transferência.`
      });
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Não foi possível copiar o valor.'
      });
    }
  }
}
